import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import type { DefineComponent } from 'vue';

type PageResolver = () => Promise<DefineComponent>;

const rootPages = import.meta.glob<DefineComponent>('./modules/**/pages/**/*.vue');
const modulePages = import.meta.glob<DefineComponent>('../../Modules/*/resources/js/pages/**/*.vue');

const pages: Record<string, PageResolver> = {
    ...rootPages,
    ...Object.fromEntries(
        Object.entries(modulePages).map(([path, resolver]) => [
            path.replace(/^..\/..\/Modules\/[^/]+\/resources\/js\/pages\//, './'),
            resolver,
        ]),
    ),
};

export function resolveInertiaPage(name: string) {
    return resolvePageComponent(`./${name}.vue`, pages);
}
